export default __webpack_public_path__ + "static/media/C1.e45b7d5d.mp3";